var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1263 1280",
    xmlns: "http://www.w3.org/2000/svg",
    width: "45px",
    height: "45px",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552.5 144 55 643h217.5L409 506.5V992l143.5 143.5V144ZM712 144l497.5 499H992L855.5 506.5V992L712 1135.5V144Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensor);
export default __webpack_public_path__ + "static/media/tensor.1bcfe2cf57cc149f28d957ff978b5ab4.svg";
export { ForwardRef as ReactComponent };